export default __webpack_public_path__ + "static/medium-image-richinstead-2-1d98113b760c24cdb58570077c6bb2ca.png";